<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px', fullScreenBackdrop: true}"></ngx-loading>
<nb-card class="p-md-4">
  <nb-card-header>
    <h1 class="header-text text-center font-weight-bold">
      SERVICE AGREEMENT
    </h1>
  </nb-card-header>
  <nb-card-body id="printSection" class="classDivBody">
    <div class="row p-2 border border-dark" *ngIf="showTermsAndConditions">
      <div class="col-12">
        <h1 class="text-center font-weight-bold d-none">
          SERVICE AGREEMENT
        </h1>
        <hr class="border border-dark" />
        <p>
          This Service Agreement (this "Agreement") is made and entered into as of the
          {{ dateVal | date: 'd' }}th day of {{ dateVal | date: 'MMMM' }}, {{ dateVal | date: 'y' }} (the
          "Effective Date"), by and between TTN Fleet Solutions ("TTNFS") of 202 Cook St. Argyle, TX 76226 and
          {{companySummaryInformation?.firstname}} {{companySummaryInformation?.lastname}},
          {{companyDetails.companyName}}, ("CLIENT")
          of {{companySummaryInformation?.address}}, {{companySummaryInformation?.city}},
          {{companySummaryInformation?.stateTypeId}}, {{companySummaryInformation?.zip}}
          on {{ dateVal | date: 'd' }}th day of {{ dateVal | date: 'MMMM' }}, {{ dateVal | date: 'y' }}
        </p>
        <h4 class="text-center">TTN Fleet Solutions - Rate Schedule</h4>
        <p>
          This Rate Schedule, supplements and amends the terms of the Services Agreement, entered into by the
          undersigned
          CLIENT and TTNFS, and are hereby intended to constitute and shall constitute a part of the Agreement effective
          as of the date signed below.
        </p>
        <p>
          For handling the calls and payments to service providers, CLIENT agrees to pay TTNFS the following fees:
        </p>
        <div class="row text-center">
          <div class="col-6">WO Fee <br /> ${{Rate}} </div>
          <div class="col-6">Tech Review/ Remittance <br /> {{Percentage}}%</div>
        </div>
        <p>
          All rates are based on the following payment method being, ACH, wire transfer. Also predicated on Electronic
          Event Submission. Any other form of payment must be approved and may be subject to additional costs.
        </p>
        <br />
        <h4 class="text-center">Payments shall be due within NET 30 of TTNFS submitting final invoice to CLIENT.</h4>
        <ol>
          <li><u>Client Participation and Fees.</u> By entering this
            Agreement, the Client agrees to pay TTNFS the Fee(s) set forth in
            the attached Rate Schedule for all services arranged by TTNFS. In
            addition to the fee(s) Client agrees to pay all vendor charges for
            services provided and invoiced where vendor is paid by TTNFS
            directly. Customer agrees to pay invoice upon receipt without
            offset based on the terms set forth in this agreement.</li>
          <li><u>Consolidated Payment to Third Party Vendors Through
              TTNFS.</u> In all transactions, excluding client National Account
            billing programs, Customer selects to have TTNFS pay vendors
            directly after completion of services, TTNFS shall submit to
            Customer an invoice with final charges for payment. The Customer
            shall pay invoice upon receipt without offset based on the terms
            set forth in this agreement. Customer acknowledges and agrees that
            all services are provided by third party vendors other than TTNFS
            and that Client is solely responsible for payment of all charges
            accrued and payable to TTNFS without offset.</li>
          <li><u>Damages/Limitation of Liability.</u> Client agrees that
            liability for all damages related to the services requested,
            attempted or performed lies exclusively with the vendor that
            performed work on Client's equipment. In the event Client asserts
            that any work was improperly performed or that any invoice for
            such work is not correct, Client agrees to notify TTNFS within
            fourteen (14) days from the date the invoice was initiated or send
            an email to disputes@ttnfs.com.</li>
          <li><u>Term</u> This agreement shall be for a period of one
            (1) year beginning on the date set forth above and shall continue
            year-to-year thereafter until terminated by either party. Any
            notice to be given to a party here under shall be writing and set
            at the address set forth above by certified or registered, return
            receipt requested within 90 days of termination.</li>
          <li><u>Default</u> This agreement may be terminated by TTNFS
            in the event the client violates any provision of this agreement.
            In the event of default of payment, TTNFS may send payment invoice
            and the client agrees to pay late fees equal to the maximum
            interest rate per month allowed by law. Furthermore, the client
            agrees to pay all collection costs incurred by TTNFS to enforce
            the terms and conditions of this agreement, including court costs,
            actual attorneyâ€™s fees, and collection agency fees.</li>
          <li><u>Notice</u> Any notice to be given to a party here under
            shall be writing and sent at the address set forth above by
            certified or registered, return receipt requested U.S. Mail;
            overnight courier or personal delivery within 90 days of
            termination.</li>
          <li><u>Waiver</u> Neither the failure nor any delay on the
            part of TTNFS to exercise any right, power or privilege here under
            shall operate as a waiver thereof.</li>
          <li><u>Promised</u> Volume Under this agreement, the promised
            WO fee shall be based on the amount of volume delivered. However,
            the WO fee shall be subject to change after every quarterly review
            and the notified party will be made aware via email.</li>
        </ol>
        <br />
        <h4>ELECTRONIC FUNDS TRANSFER INSTRUCTIONS</h4>
        <p>
          Account Name: Towing Network LLC <br />
          Account Address: 202 Cook Street Argyle, TX 76226 <br /><br />
          Account Number: 609224386 <br />
          ABA Routing Number: 114000093 <br /><br />
          Bank Name: Frost Bank <br />
          Bank Address: PO Box 16509 Fort Worth, TX 76162 <br /><br />
          Remittance Email: accounting@ttnfs.com <br /><br />
          IN WITNESS WHEREOF, the parties here to have executed this Agreement and have duly affixed their signatures
          under hand and seal on this {{ dateVal | date: 'd' }}th day of {{ dateVal | date: 'MMMM' }},
          {{ dateVal | date: 'y' }}.
        </p>
        <div class="row">
          <div class="col-5">
            TTN FLEET SOLUTIONS <br /><br /> by: __________________________________________ <br /><br />Authorized
            Signature <br />Tyler Harden, EVP
          </div>
          <div class="col-6 text-right">
            &nbsp;&nbsp; __________________________________________ <br /><br /> by:
            __________________________________________ <br /><br />Authorized Signature
            <br />{{companySummaryInformation?.firstname}} {{companySummaryInformation?.lastname}}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 iframe-div" *ngIf="agreementPresent">
      <iframe class="embed-responsive-item"
        [src]="agreementURL"></iframe>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="row mt-3">
      <div class="col text-right ">
        <button (click)="decline()" class="btn btn-danger mr-1">Decline </button>
        <button (click)="accept()" class="btn btn-success">I Agree</button>
        <button *ngIf="printBtn" title="Print Terms And Conditions" class="btn btn-success ml-1" printSectionId="printSection"
          ngxPrint><i class="fa fa-print" aria-hidden="true"></i></button>
      </div>
    </div>
  </nb-card-footer>
</nb-card>
